import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { notNil } from '@robocorp/robocloud-shared-utils';
import { useListAssetUploadsQuery } from '~/queries/useAssetStorageQuery';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectAssetUploadId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const { data = [], isInitialLoading: isLoading } = useListAssetUploadsQuery(
    pathParameters.asset_id as string,
    {
      enabled: notNil(pathParameters.asset_id),
    },
  );

  const items = useMemo(
    () =>
      data.map((item) => ({
        label: item.assetId,
        value: item.assetId,
      })),
    [data],
  );

  return (
    <ApiHelperSelectInput
      label={t('assetStorage.upload')}
      items={items}
      onChange={(value) => setValue('upload_id', value)}
      loading={isLoading}
      value={value}
      {...props}
    />
  );
};
